import React from 'react';
import './Event_about.css';

const Event_about = () => {
    const state = {
        FourKeys_item: [
            {
                title: 'Engines',
                topics: [
                    'A refreshingly simple data-driven game engine built in Rust',
                    'Desktop/Android/HTML5/iOS Java game development framework',
                    'egui: an easy-to-use immediate mode GUI in Rust that runs on both web and native',
                    'How to make games in Unreal Engine 5',
                ],
            },
            {
                title: 'AI',
                topics: [
                    'Artificial Intelligence behaviour programming for enemies',
                    'Bullet Physics SDK',
                    'Physical Computing & Alternative Interfaces',
                ],
            },
            {
                title: 'Grafics',
                topics: [
                    'Fast and lightweight JavaScript game engine built on WebGL and glTF',
                    'Unreal Gameplay Framework to make games easily',
                    'Script logic to define gameplay without needing to know how to code',
                    '2D and 3D Graphics in Games',
                    '3D graphics: APIs using fixed algorithms',
                    'Digital motion capture',
                ],
            },
            {
                title: 'Game design',
                topics: [
                    'Tile-Based Game Design',
                    'Player Archetypes: Bartle Taxonomy',
                    'Gamification: Gamify the Player Experience',
                    'Flow Charts: In and Outs of Gameplay Loops',
                    '3D vs 2D: The Eternal Battle to Develop Video Games',
                ],
            },
            {
                title: 'Rendering',
                topics: [
                    'Object Oriented Programming and how to put it into practice',
                    'C++, the games industry standard language',
                    'Pixel-Perfect Collision and Destructible Environments',
                    'Rasterization and the Rendering Pipeline',
                    'Interactive 3D renders with WebGL',
                    'Real-Time Rendering vs Pre-Rendering',
                    'Rendering Using Game Engines',
                ],
            },
        ],
    };

    const renderGetReady = (item, i) => {
        return (
            <div className="getReady_item" key={`getReady_item-${i}`}>
                <div className='getReady_item--title_block'>
                    <h3 className='getReady_item--title'>{item.title}</h3>
                </div>
                <ul className='getReady_ul'>
                    {item.topics.map(item => <li className='getReady_li p2' key={`getReady_li-${i + item}`}><span>_</span> {item}</li>)}
                    <p className='p2'>And others</p>
                </ul>
            </div>
        );
    };

    return (
        <div className='getReady_wrap'>
            <div className='container getReady'>
                <h2 className='getReady_title colorful'>What event is about</h2>
                <div className='getReady_block'>
                    {state.FourKeys_item.map((item, i) => renderGetReady(item, i))}
                </div>
            </div>
        </div>
    );
};

export default Event_about;